module.exports = __webpack_public_path__ + "static/img/2-02.fd4fb93.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/custDetail/2-02.png
// module id = pF5y
// module chunks = 1